import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const ContextoDeInspecao = createContext(null);
export function InspecaoProvider({ children }) {
    const [ultima, setUltima] = useState(null);
    const registrar = useCallback((chamada) => setUltima(chamada), []);
    const inspecao = useMemo(() => ({ ultima, registrar }), [ultima, registrar]);
    return _jsx(ContextoDeInspecao.Provider, { value: inspecao, children: children });
}
export function useInspecao() {
    const inspecao = useContext(ContextoDeInspecao);
    if (inspecao === null) {
        throw new Error('useInspecao exige InspecaoProvider acima na árvore');
    }
    return inspecao;
}
